export const PRODUCT_MEDIA_ITEM_TYPES = [
  { id: 0, key: "image" },
  { id: 1, key: "embedded_video" },
]
